export default __webpack_public_path__ + "static/palette-jira-board-light-e148298844d210d97f2879d076bcbccd.png";